/**
* Featured Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    className: 'featured-services',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      if ( $( '.featured-services' ).length ) {
        const splides = [];

        $( '.featured-services__splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 2,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1269: {
                perPage: 2,
              },
              768: {
                perPage: 1,
                gap: '20px',
              },
            },
          } ).mount();

          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );

          splides.push( splide );
        } );

        $( '[data-toggle-radio-group="featured-services-slider"]' ).on( 'click', function() {
          const targetId = $( this ).data( 'toggle-target' );
          const $target = $( targetId );

          if ( $target.length ) {
            const splide = splides.find( ( sp ) =>
              $( sp.root ).closest( targetId ).length,
            );
            if ( splide ) {
              splide.refresh();
            }
          }
        } );
      }
    },
    finalize: function() {},
  };

  app.registerComponent( 'featured-services', COMPONENT );
} )( app );
